/**
 * Ring/number color for a team-colored player dot.
 *
 * Light kits (white, pale yellow, sky blue) drew a white ring and white
 * jersey number on a near-white fill — an unreadable blob. Perceived
 * brightness of the fill decides ring/text color; the team color itself is
 * never altered so dots still match the broadcast kit.
 *
 * Exact port of `_dotContrast` from upstream main commit 68cfd4f (the Jinja
 * match page, deleted on this branch): same BT.601 brightness formula, same
 * 170/255 threshold (strictly greater-than), same dark color values, same
 * rgb(153,153,153) fallback for anything that is not a 3- or 6-digit hex —
 * so this page and production render identically at merge day. Do not
 * "improve" the heuristic here without changing upstream in the same act.
 */
export function dotContrast(color: string): { ring: string; number: string } {
  let r = 153
  let g = 153
  let b = 153
  const hex6 = /^#([0-9a-f]{6})$/i.exec(color.trim())
  const hex3 = /^#([0-9a-f]{3})$/i.exec(color.trim())
  if (hex6) {
    const h = hex6[1] ?? ''
    r = parseInt(h.slice(0, 2), 16)
    g = parseInt(h.slice(2, 4), 16)
    b = parseInt(h.slice(4, 6), 16)
  } else if (hex3) {
    const h = hex3[1] ?? ''
    r = parseInt(h.charAt(0) + h.charAt(0), 16)
    g = parseInt(h.charAt(1) + h.charAt(1), 16)
    b = parseInt(h.charAt(2) + h.charAt(2), 16)
  }
  const brightness = 0.299 * r + 0.587 * g + 0.114 * b
  return brightness > 170
    ? { ring: 'rgba(20, 23, 28, 0.9)', number: '#14171c' }
    : { ring: 'white', number: 'white' }
}
